var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"row"},[_c('H1',[_vm._v("test")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }